import { makeExteriorWallSegments } from "building-generation/utils/floorplan";
import type { SheetGeometry } from "building-types/views/sheetGeometryTypes";
import { sheetPolylineGeometryNew } from "building-types/views/sheetGeometryTypes";
import { WallLayerType } from "building-types/walls/wallEnums";
import type { PlanGenerationContextBase } from "doc/plans/planGeometrySource";
import { getExteriorWallSubstrateOffset } from "doc/utils/wallTypeTools";
import { offsetPolyLine2 } from "geom/offset";

export function makeSheetGeometryWallExteriorPerimeters({
  building,
  levelId,
}: PlanGenerationContextBase): SheetGeometry[] {
  const result: SheetGeometry[] = [];

  const dimensionBehavior = building.dimensionBehavior[levelId];
  const { offsetExterior } = makeExteriorWallSegments({
    building,
    levelId,
    includeDoors: false,
    includeWindows: false,
    includeExteriorRooms: true,
    wallLayer: WallLayerType.STRUCTURE,
    dimensionBehavior,
  });

  if (offsetExterior.length > 0) {
    result.push(
      sheetPolylineGeometryNew({
        handle: building.levels[levelId].handle,
        paths: offsetExterior,
      }),
    );
  }

  return result;
}

export function makeSheetGeometryFloorPlateExteriorPerimeters({
  building,
  levelId,
}: PlanGenerationContextBase): SheetGeometry[] {
  if (building.floorPlates[levelId].perimeterPolyLine2s.length > 0) {
    const offsetDistance = getExteriorWallSubstrateOffset(building.settings.wall);
    return [
      sheetPolylineGeometryNew({
        handle: building.levels[levelId].handle,
        paths: [offsetPolyLine2(building.floorPlates[levelId].perimeterPolyLine2s[0], -offsetDistance)],
      }),
    ];
  }
  return [];
}
